import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { CartService } from "src/app/services/cart.service";
import { ProductService } from "src/app/services/product.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import Swal from "sweetalert2";
import { resolveImageUrl } from "src/app/core/utils/image.util";
import SwiperCore, { Autoplay } from 'swiper/core';
SwiperCore.use([Autoplay]);


import { BannerService } from "src/app/services/banner.service";

export interface Slide {
  id: number;
  link: string;
  title: string;
  endDate: Date;
  startDate: Date;
  active: boolean;
}

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeComponent implements OnInit, OnDestroy {
  categories = [
    { name: "Tecnología & Gadgets", value: "Tecnología", img: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=600&q=80", subtitle: "Innovación, dispositivos y audio de alta fidelidad" },
    { name: "Moda & Accesorios", value: "Moda y Calzado", img: "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?auto=format&fit=crop&w=600&q=80", subtitle: "Colecciones exclusivas y tendencias de temporada" },
    { name: "Hogar & Confort", value: "Hogar y Confort", img: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?auto=format&fit=crop&w=600&q=80", subtitle: "Espacios sofisticados y detalles para tu hogar" },
    { name: "Belleza & Cuidado", value: "Belleza", img: "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?auto=format&fit=crop&w=600&q=80", subtitle: "Cuidado personal y estética de vanguardia" }
  ];

  isModalOpen = false;
  modalProduct: any = null;
  modalAvailableSizes: any[] = [];
  modalSelectedSize: any = null;
  modalSelectedColor: string = '';
  modalSelectedColorObj: any = null;

  products: any[] = [];
  activeBanners: any[] = [];
  currentBannerIndex: number = 0;
  bannerInterval: any;

  testimonials = [
    { name: 'Ana López', comment: '¡Me encantó la calidad y el diseño!', stars: 5, photo: 'assets/testimonials/ana.jpg' },
    { name: 'Carlos Pérez', comment: 'El envío fue rapidísimo y el producto excelente.', stars: 4, photo: 'assets/testimonials/carlos.jpg' },
    { name: 'María García', comment: 'Muy buena atención al cliente. ¡Repetiré!', stars: 5, photo: 'assets/testimonials/maria.jpg' }
  ];
  
  currentTestimonial = 0;
  email: string = '';
  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private productService: ProductService,
    private cartService: CartService,
    private bannerService: BannerService
  ) {}

  ngOnDestroy(): void {
    if (this.bannerInterval) clearInterval(this.bannerInterval);
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.loadOutstandingProducts();
    this.loadActiveBanners();
  }

  loadActiveBanners(): void {
    this.bannerService.getActiveBanners().pipe(takeUntil(this.destroy$)).subscribe(
      (banners) => {
        if (Array.isArray(banners) && banners.length > 0) {
          this.activeBanners = banners;
          this.startBannerRotation();
        }
      },
      (err) => console.error("Error cargando banners dinámicos:", err)
    );
  }

  startBannerRotation(): void {
    if (this.activeBanners.length > 1) {
      this.bannerInterval = setInterval(() => {
        this.currentBannerIndex = (this.currentBannerIndex + 1) % this.activeBanners.length;
      }, 5000);
    }
  }

  setBannerIndex(idx: number): void {
    this.currentBannerIndex = idx;
  }

  prevBanner(): void {
    if (this.activeBanners.length > 0) {
      this.currentBannerIndex = (this.currentBannerIndex - 1 + this.activeBanners.length) % this.activeBanners.length;
    }
  }

  nextBanner(): void {
    if (this.activeBanners.length > 0) {
      this.currentBannerIndex = (this.currentBannerIndex + 1) % this.activeBanners.length;
    }
  }

  resolveImg(imgUrl: any): string {
    if (!imgUrl) return 'assets/img/no-image.png';
    let url = '';
    if (Array.isArray(imgUrl) && imgUrl.length > 0) {
      url = imgUrl[0];
    } else if (typeof imgUrl === 'string') {
      const trimmed = imgUrl.trim();
      if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
        try {
          const parsed = JSON.parse(trimmed.replace(/'/g, '"'));
          url = Array.isArray(parsed) ? parsed[0] : trimmed;
        } catch {
          url = trimmed;
        }
      } else if (trimmed.includes(',')) {
        url = trimmed.split(',')[0].trim();
      } else {
        url = trimmed;
      }
    }
    return resolveImageUrl(url);
  }

  onImageError(event: any): void {
    if (event?.target && !event.target.getAttribute('data-error-handled')) {
      event.target.setAttribute('data-error-handled', 'true');
      event.target.src = 'assets/img/no-image.png';
    }
  }

  loadOutstandingProducts() {
    this.productService.getProducts().pipe(takeUntil(this.destroy$)).subscribe(
      (response: any) => {
        const rawProducts = Array.isArray(response?.data) ? response.data : (Array.isArray(response) ? response : []);
        if (rawProducts.length > 0) {
          const featured = rawProducts.filter((p: any) =>
            p.isFeatured === true || String(p.isFeatured) === 'true' || p.isFeatured === 1 ||
            p.isOutstanding === true || String(p.isOutstanding) === 'true' || p.isOutstanding === 1 ||
            p.outstanding === true || String(p.outstanding) === 'true' || p.outstanding === 1
          );
          this.products = featured;
        }
      },
      (error) => {
        console.error("Error al cargar productos destacados:", error);
      }
    );
  }

  
  goToShop() {
    this.router.navigate(["/shop"]);
  }

  getSlidesPerView() {
    if (window.innerWidth >= 1024) return 3;
    if (window.innerWidth >= 768) return 2;
    return 1;
  }


  goToCategory(cat: any) {
    this.router.navigate(["/shop"], { queryParams: { category: cat.value } });
  }

  addToCart(product: any) {
   
  }

  // Abre el modal y carga las tallas disponibles
openProductModal(product: any) {
  this.modalProduct = product;
  this.isModalOpen = true;
  this.modalAvailableSizes = product.sizes || [];
  this.modalSelectedSize = null;
  this.modalSelectedColor = '';
}

// Cierra el modal
closeModal() {
  this.isModalOpen = false;
  this.modalProduct = null;
  this.modalAvailableSizes = [];
  this.modalSelectedSize = null;
  this.modalSelectedColor = '';
}

// Selecciona talla
selectSize(size: any) {
  this.modalSelectedSize = size.valor;
  this.modalSelectedColor = '';
}

// Devuelve los colores disponibles para la talla seleccionada
getColorsForSelectedSize() {
  if (!this.modalProduct || !this.modalProduct.sizes) return [];
  const sizeObj = this.modalProduct.sizes.find((s: any) => s.valor === this.modalSelectedSize);
  return sizeObj ? sizeObj.colors : [];
}

// Selecciona color
selectColor(color: string) {
  this.modalSelectedColor = color;
}

// Devuelve el stock disponible para la talla y color seleccionados
getAvailableStock(sizeValor: string, color: string) {
  const sizeObj = this.modalProduct.sizes.find((s: any) => s.valor === sizeValor);
  if (!sizeObj) return 0;
  const colorObj = sizeObj.colors.find((c: any) => c.color === color);
  return colorObj ? colorObj.cant : 0;
}

// Estilo para el botón de color
getColorStyle(color: string) {
  return { 'background-color': color };
}

// Confirmar selección (agregar al carrito)
confirmSelection() {
  this.cartService.addToCart(
    this.modalProduct,
    1,
    this.modalSelectedSize,
    this.modalSelectedColor
  );
  Swal.fire({
    icon: "success",
    title: "¡Producto agregado al carrito!",
    text: `El producto se ha añadido con la talla ${this.modalSelectedSize} y color ${this.modalSelectedColor}`,
    confirmButtonColor: "#3085d6",
    timer: 2000,
    showConfirmButton: false,
  });
  this.closeModal();
}


hasStockForSize(size: any): boolean {
  // Si el objeto size tiene un array de colores, revisa si alguno tiene stock
  if (!size.colors || !Array.isArray(size.colors)) return false;
  return size.colors.some((color: any) => color.cant > 0);
}

subscribe() {
  if (this.email && this.email.includes('@')) {
    // Aquí puedes llamar a tu servicio para guardar el email si tienes backend
    alert('¡Gracias por suscribirte! Pronto recibirás nuestras novedades.');
    this.email = '';
  } else {
    alert('Por favor, ingresa un correo válido.');
  }
}
}
